var TruffleError = require("truffle-error");
var inherits = require("util").inherits;

inherits(ConfigurationError, TruffleError);

function ConfigurationError(message) {
    ConfigurationError.super_.call(this, message);
}

module.exports = ConfigurationError;



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-core/lib/errors/configurationerror.js
// module id = 452
// module chunks = 0